module.exports = __webpack_public_path__ + "static/media/apple-logo.50f08c20.svg";